import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: false,
  status: "success",
  msg: "",

  openSnackbar: false,
  statusSnackbar: "success",
  msgSnackbar: "",
};

const alertStatusSlice = createSlice({
  name: "alertStatus",
  initialState,
  reducers: {
    setAlertError: (state, action) => {
      return {
        open: true,
        status: "error",
        msg: action.payload.message,
      };
    },
    setAlertSuccess: (state, action) => {
      return {
        open: true,
        status: "success",
        msg: action.payload,
      };
    },
    clearAlert: () => {
      return {
        open: false,
        status: "success",
        msg: "",
      };
    },

    alertSnackbarSuccess: (state, action) => {
      return {
        openSnackbar: true,
        statusSnackbar: "success",
        msgSnackbar: action.payload,
      };
    },

    alertSnackbarError: (state, action) => {
      return {
        openSnackbar: true,
        statusSnackbar: "error",
        msgSnackbar: action.payload,
      };
    },
    clearalertSnackbar: () => {
      return {
        openSnackbar: false,
        statusSnackbar: "success",
        msgSnackbar: "",
      };
    },
  },
});

const { reducer, actions } = alertStatusSlice;

export const {
  setAlertError,
  setAlertSuccess,
  clearAlert,
  alertSnackbarSuccess,
  alertSnackbarError,
  clearalertSnackbar,
} = actions;
export default reducer;
